import { useEffect, useState } from "react";

import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";

export const useDashboard = () => {
  const theme = useTheme();
  const mdMatched = useMediaQuery(theme.breakpoints.down("md"));
  const [isSidebarClosed, setSidebarClosed] = useState<boolean>(false);
  const [openDrawer, setOpenDrawer] = useState<boolean>(false);

  useEffect(() => {
    if (!mdMatched || isSidebarClosed) return;
    setSidebarClosed(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mdMatched]);

  const handleToggleDrawer = () => setOpenDrawer((prevState) => !prevState);

  const handleToggleSidebar = () => {
    if (mdMatched) {
      handleToggleDrawer();
      return;
    }
    setSidebarClosed((prevState) => !prevState);
  };

  return {
    mdMatched,
    openDrawer,
    isSidebarClosed,
    handleToggleSidebar,
    handleToggleDrawer,
  };
};
